import React, { Dispatch, SetStateAction, useState } from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

type MOStep1Props = {
	setCurrentStep: Dispatch<SetStateAction<number | string>>;
	membershipQuestions: any;
	setMembershipQuestions: Dispatch<any>;
};

export const MOStep1: React.FC<MOStep1Props> = ({
	setCurrentStep,
	membershipQuestions,
	setMembershipQuestions,
}) => {
	const [initialDetails, setInitialDetails] = useState<any>(membershipQuestions);	

	const validationSchema = Yup.object({
		selectedLocation: Yup.number().required('Please select a location').nullable(),
	});	

	const handleSubmit = async (values: any) => {
		setMembershipQuestions(values);
		setCurrentStep(
			values.selectedLocationLabel.toLowerCase() !== "united kingdom" ? 
			"NonUK" : 2
		);
	};

	return (
		<>
			<div className="MOSpeechBubbleQuestion">
				<div className="SpeechBubbleQ">
					<h1>Where is your school based?</h1>
				</div>
			</div>

			<Formik
				initialValues={initialDetails}
				onSubmit={handleSubmit}
				validateOnChange={false}
				validateOnBlur={false}
				validateOnMount={false}
				enableReinitialize={true}
				validationSchema={validationSchema}
			>
				{(formik) => {
					let values: any = formik.values;
					
					return (
						<Form>
							<div className="MOQForm">
								{formik.errors.selectedLocation && <p className="ErrorTxt">{(formik as any).errors.selectedLocation}</p>}
								<div className="RadioBtnsList">
									{values.locationTypes.map((option: any, index: number) => {
										return (
											<div 
												key={option.id}
												className={"RBBlock" + ((index === 0 && values.unitedKingdom[0].id === values.selectedLocation) || option.id === values.selectedLocation ? " Checked" : "")}
												onClick={() => {
													formik.setFieldValue("selectedLocation", index === 0 ? values.unitedKingdom[0].id : option.id);
													formik.setFieldValue("selectedLocationLabel", option.name);
												}}
											>
												<div className="Checkbox">
													<input id={"MO_Radio_" + index} type="radio" name={"MO_Radio_List"} checked={(index === 0 && values.unitedKingdom[0].id === values.selectedLocation) || option.id === values.selectedLocation} readOnly />
													<label className="CustomInput" htmlFor={"MO_Radio_" + index}>
														{option.name}
													</label>
												</div>
											</div>
										);
									})}									
								</div>

								<div className="Btn BtnOrange SubmitBtn" onClick={formik.submitForm}>Next question</div>
							</div>
						</Form>
					);
				}}
			</Formik>
		</>
	);
};